/** Client-side notification row builders (sync outbox). */
import type { NotificationItem } from './types.js';

export function notifSync(pending: number, failed: number): NotificationItem[] {
  if (pending <= 0 && failed <= 0) return [];
  return [
    {
      id: 'sync',
      kind: 'sync',
      stateToken: `p${pending}:f${failed}`,
      priority: 30,
      title: failed > 0 ? 'Sync failed' : 'Items waiting to sync',
      subtitle:
        failed > 0
          ? `${failed} failed · ${pending} pending`
          : `${pending} change${pending === 1 ? '' : 's'} in the outbox`,
      target: { type: 'settings_sync' },
    },
  ];
}
